export const PUSH_FAVOURITE = 'PUSH_FAVOURITE';
